import { IEnvironment } from "./IEnvironment";
import { environment as defaultEnvironment } from "./environment.default";

export const environment: IEnvironment = {
    ...defaultEnvironment,
    env: 'dev',
    clientId: '7Pan2745CAlZ9ukZgUi4sKkj7tuLFXFe',
    domain: 'login-dev.cinchhs.com',
    xApiKey: 'OHfwLZxs9Y58ZXFV4dmd4aAkyBt330JF2fFHRip8',
    footerBaseUrl: {
        ...defaultEnvironment.footerBaseUrl,
    },
    automaticDecision: {
        serviceProvider: '700001342'
    },
    ByopServiceProvider:'700001496',
    SrgOrTxSrgServiceProviders: {
        ...defaultEnvironment.SrgOrTxSrgServiceProviders
    },
    procureVendorServiceProvider: defaultEnvironment.procureVendorServiceProvider,
    roofLeakServiceProvider: defaultEnvironment.roofLeakServiceProvider,
    pazeUrl: defaultEnvironment.pazeUrl,
    pazeClient: {
        ...defaultEnvironment.pazeClient
    },
    msClarityProjectId: 'qnm1428a3z',
    hotJarProjectId: '5335614',
    cxOneGuideInitId: defaultEnvironment.cxOneGuideInitId,
    spCompeteServiceProvider: '700002184',
};
